import { ChainId, ERC20Token, WMATIC } from '@nominex/nomiswap-sdk'
import { ERC20TokensMap } from './types'

export const tokens: ERC20TokensMap = {
  busd: new ERC20Token(
    ChainId.MATIC,
    '0xdAb529f40E671A1D4bF91361c21bf9f0C9712ab7',
    18,
    'BUSD',
    'Binance USD',
    'https://www.paxos.com/busd/',
  ),
  dai: new ERC20Token(
    ChainId.MATIC,
    '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    18,
    'DAI',
    'Dai Stablecoin',
    'https://makerdao.com',
  ),
  nmx: new ERC20Token(
    ChainId.MATIC,
    '0x0cb93b5c42437FE78b3697740D15b46707f97361',
    18,
    'NMX',
    'Nominex Token',
    'https://nominex.io/',
  ),
  usdc: new ERC20Token(
    ChainId.MATIC,
    '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    6,
    'USDC',
    'USD Coin',
    'https://www.centre.io/',
  ),
  usdt: new ERC20Token(
    ChainId.MATIC,
    '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    6,
    'USDT',
    'Tether USD',
    'https://mapper.polygon.technology/',
  ),
  wbtc: new ERC20Token(
    ChainId.MATIC,
    '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
    8,
    'WBTC',
    'Wrapped BTC',
    'https://www.wbtc.network',
  ),
  wmatic: WMATIC[ChainId.MATIC],
}
